import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  content: css`
    display: flex;
    flex-direction: column;
  `,
  recentSearchesContainer: css`
    padding: 16px;
  `,
  savedSearchesContainer: css`
    padding: 16px 8px 16px 16px;
  `,
  linkButton: css`
    &.MuiButton-root {
      padding-right: 0px !important;
    }
  `,
  searchBarContainer: css`
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 0px 20px 8px 12px;
    color: ${colors.prussian};
  `,
  searchBar: css`
    &.MuiOutlinedInput-root {
      font-size: 14px;
      font-family: 'Montserrat Medium';
      color: ${colors.prussian};
      padding-left: 10px;
      width: 100%;
    }
    & > .MuiOutlinedInput-input {
      padding: 7.5px 0px;
    }
    & > .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${colors.prussian600} !important;
      border-radius: 10px;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
    }
  `,
  searchHeader: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `,
  link: css`
    font-size: 13px;
    color: ${colors.jungle};
    text-decoration: underline;
  `,
  searchRow: css`
    display: flex;
    justify-content: space-between;
    padding-top: 16px;
  `,
  iconStone: css`
    color: ${colors.stone};
  `,
  closeIcon: css`
    color: ${colors.neutralAsh};
  `,
  savedSearches: css`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 16px;
  `,
  topSearchesContainer: css`
    padding: 16px;
  `,
  searchItem: css`
    display: flex;
    gap: 9.7px;
    cursor: pointer;
  `,
  previouslyPosted: css`
    display: flex;
    padding-bottom: 12px;
    color: ${colors.slate};
  `,
  textBold: css`
    font-weight: bold;
  `,
  cancelIcon: css`
    color: ${colors.silver} !important;
  `,
  buttonCancelSpacing: css`
    padding-left: 16px;
  `,
  separator: css`
    border-top: 1px solid #e6e6e6;
    margin: 4px 16px;
  `,
};

export default styles;
